<template>
  <div class="actions">
    <button class="add-btn" @click="$emit('addTimeblock')">+</button>
    <button
      :disabled="!props.deletable"
      class="delete-btn"
      @click="$emit('removeTimeblock')"
    >
      ×
    </button>
  </div>
</template>

<script setup lang="ts">
interface Props {
  deletable: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  deletable: false,
});

defineEmits<{
  (e: 'addTimeblock'): void;
  (e: 'removeTimeblock'): void;
}>();
</script>

<style lang="sass" scoped>
.actions
  display: flex
  align-items: center
  gap: 8px

  .add-btn
    background: #7f39fb
    color: white
    border: none
    border-radius: 4px
    width: 44px
    height: 44px
    font-size: 28px
    cursor: pointer
    display: flex
    align-items: center
    justify-content: center
    transition: all 0.2s
    line-height: 1

    &:hover
      background: #6825e0

  .delete-btn
    background: #ff5252
    color: white
    border: none
    border-radius: 4px
    width: 44px
    height: 44px
    font-size: 28px
    cursor: pointer
    display: flex
    align-items: center
    justify-content: center
    transition: all 0.2s
    line-height: 1

    &:disabled
      opacity: 0.5
      cursor: not-allowed

    &:hover
      background: #ff1744
</style>
